import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-sanction-form',
  templateUrl: './training-sanction-form.component.html',
  styleUrls: ['./training-sanction-form.component.css']
})
export class TrainingSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Training/training-sanction/training-sanction-form/training-sanction-form.component.ts